import RichTable from 'app/shared-components/RichTableReduxWrapper'

import useGetPreviousOrdersByOrder from './hooks/useGetPreviousOrdersByOrder'
import columns from './previousOrders.columns'
import useStyles from './PreviousOrders.style'

const DOMAIN_NAME = 'Order'
const PreviousOrders = ({
    orderNumber,
}: { orderNumber: string }) => {
    const {
        classes,
    } = useStyles()

    const {
        onParamsChange,
        loadData,
    } = useGetPreviousOrdersByOrder(orderNumber)

    return (
        <RichTable
            configName="InternalTransportsOverview.PreviousOrders"
            name={DOMAIN_NAME}
            load={loadData}
            onParamsChange={onParamsChange}
            columns={columns}
            className={classes.tableContent}
            classNames={{
                contentWrapper: classes.tableContentWrapper,
            }}
        />
    )
}

export default PreviousOrders
